// AI-Powered Finance Solutions Hero Section Data
export const AI_POWERED_FINANCE_HERO_DATA = {
  heading: 'AI-powered finance solutions for individuals and teams worldwide',
  productCards: [
    {
      id: 'clear_finance_cloud',
      heading: 'Clear Finance Cloud',
      content:
        'An AI-powered finance ecosystem built to help finance teams gain control, accuracy, and savings.',
      buttonText: 'Learn more',
      CTAButtonLink:
        'https://www.clear.in/clear-finance-cloud?utm_ref=cleartax_homepage_herofold',
      icon: 'https://assets.clear.in/cleartax/images/1695378321_group1814218634.png',
      classes: 'card2 hero-section-outer-card hero-section-card2',
      hoverBgColor: 'hover:bg-blue-50',
    },
    {
      id: 'itr_filing',
      heading: 'ITR Filing',
      content: 'File your ITR for FY 2025-26 and with 100% accuracy.',
      buttonText: 'File Now',
      CTAButtonLink:
        'https://cleartax.in/filing?utm_ref=cleartax_homepage_herofold',
      icon: 'https://assets.clear.in/cleartax/images/1695366152_group1814217655.png',
      classes: 'card1 hero-section-outer-card hero-section-card1',
      hoverBgColor: 'hover:bg-purple-50',
    },
    {
      id: 'global_einvoicing',
      heading: 'Global e-Invoicing',
      content:
        'E-invoicing, tax compliance, supply chain automation, and more for 50+ countries.',
      buttonText: 'Learn more',
      CTAButtonLink:
        'https://cleartax.in/s/contact-sales?utm_ref=cleartax_homepage_herofold',
      icon: 'https://assets.clear.in/cleartax/images/1695378348_icon2.png',
      classes: 'card3 hero-section-outer-card',
      hoverBgColor: 'hover:bg-green-50',
    },
  ],
};
